<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import TwoFactorPage from '../../auth/pages/two_factor_login/TwoFactorPage.vue'

definePage({
    meta: {
        isGuest: true,
    }
})
</script>

<template>
  <TwoFactorPage />
</template>